import { reactive } from "vue";
import axios from "axios";

export const state = reactive({
    user: {
        firstname: '',
        name: '',
        birthday: '',
        birthplace: '',
        email: '',
        tel: '',
        addressLine1: '',
        addressLine2: '',
        state: '',
        city: '',
        country: '',
        zipcode: ''
    },
    activity: {
        isEmployee: true,
        legalStatus: '',
        siret: '',
        apeCode: '',
        businessCreation: '',
        files: []
    },
    formation: {
        certification: '',
        school: '',
        gotDegrees: false,
        precision: '',
        files: []
    },
    motivations: '',
    toast: {
        show: false,
        message: ''
    },
    postSuccess: false,
    respMsg: ''
});

axios.interceptors.request.use((config) => {
    config.headers['X-WP-Nonce'] = wpApiSettings.nonce;
    return config;
});

export async function send() {
    const data = {
        user: state.user,
        activity: state.activity,
        formation: state.formation,
        motivations: state.motivations
    };

    let formData = new FormData();

    Object.keys(data).forEach(key => {
        if (typeof state[key] !== 'object') {
            formData.append(key, state[key]);
        } else {
            formData.append(key, JSON.stringify(state[key]));
        }
    });

    state.activity.files.forEach(file => {
        formData.append(`Situation (indépendant, salarié) - ${file.name}`, file);
    });

    state.formation.files.forEach(file => {
        formData.append(`Certifications praticien - ${file.name}`, file);
    });

    await axios({
        method: 'POST',
        url: `${wpApiSettings.root}api/v1/adhesion/pro`,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData
    })
        .then(res => {
            state.postSuccess = true;
            state.respMsg = res.data;
        })
        .catch(err => {
            showToast(err.response.data.message);
        })
}

function showToast(message) {
    state.toast.show = true;
    state.toast.message = message;

    setTimeout(() => state.toast.show = false, 3000);
}